import { ContainerComponent, wrap } from 'AppReact';
import {
  SecondaryTextSm, SecondaryTextSmBold, ClickableIcon, Bullet, Icon,
  CustomText, Tooltip
} from 'atoms';
import Controller from './controller';
import internalState from './internalState';
import {
  Tr, Td, Px4, Px5, FlexCenterWrapper, Mr6, Mr3, Mr2, Pl9, Mr4,
  FlexCenterJustifyEndWrapper, WhiteSpaceNoWrap, Width350,
  CursorPointerWrapper, FlexCenterBetweenWrapper, TooltipWrapper
} from 'wrappers';
import { MultipleProgressBar } from 'molecules';
import { EyeSvg, DownloadDocumentSvg, ChevronRight, ChevronDownSvg } from 'components/icons';
import { formatPrice, textEllipsis } from 'utils';
import { getIconByName } from '../../../multipleOptionsButton/utils';

export const definition = {
  name: 'RowContainer',
  controller: Controller,
  initialProps: ({ item }) => ({ item }),
  props: internalState,
  elements: [
    {
      wrapper: Tr,
      name: 'Row',
      displayState: ({ isOpen }) => ({
        height: '48px',
        background: isOpen ? '#F3F5F5' : '#FFFFFF'
      }),
      elements: [
        {
          wrapper: Td,
          name: 'InspectionItems',
          displayState: ({ isOpen }) => ({
            borderRight: isOpen ? '' : '1px solid #E3E3E3',
            borderLeft: '1px solid #E3E3E3',
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
          }),
          elements: [
            {
              wrapper: wrap(wrap(FlexCenterWrapper, Px4), CursorPointerWrapper),
              name: 'NameWrapper',
              bindings: ({ isOpen }) => ({ isOpen }),
              isButton: true,
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Name',
                  displayValue: ({ isOpen }) => isOpen ? ChevronDownSvg({ width: 14, height: 14, color: '#566F75' }) : ChevronRight({ width: 14, height: 14, color: '#566F75' }),
                },
                {
                  wrapper: TooltipWrapper,
                  name: 'TooltipWrapper',
                  elements: [
                    {
                      wrapper: wrap(WhiteSpaceNoWrap, Width350),
                      name: '__transparent__',
                      elements: [
                        {
                          component: CustomText,
                          name: 'NameCell',
                          displayState: ({ }) => ({ fontSize: '14px', color: window?.settings?.secondary_color ?? '#04333B', clickable: true }),
                          displayValue: ({ item }) => textEllipsis(item?.name ?? '', 45)
                        },
                      ]
                    },
                    {
                      component: Tooltip,
                      name: 'Popup',
                      renderIf: ({ item }) => item?.name?.length > 45,
                      displayValue: ({ item }) => item?.name ?? '',
                      displayState: ({ }) => ({ direction: 'bottom', offset: 'start', width: '350px' })
                    }
                  ]
                },
              ]
            }
          ]
        },

        {
          wrapper: Td,
          name: 'Items',
          displayState: ({ isOpen }) => ({
            background: isOpen ? '#F3F5F5' : '#F9FAFA',
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '120px',
          }),
          elements: [
            {
              component: wrap(SecondaryTextSm, Px5),
              name: 'Items',
              displayValue: ({ item }) => `${item?.completed_items ?? 0}`,
            }
          ]
        },
        {
          wrapper: Td,
          name: 'Percentage',
          displayState: ({ isOpen }) => ({
            borderRight: isOpen ? '' : '1px solid #E3E3E3',
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '120px',
          }),
          elements: [
            {
              component: wrap(SecondaryTextSm, Px5),
              name: 'Percentage',
              displayValue: ({ item }) => `${item?.percentage_complete ?? 0}%`,
            }
          ]
        },
        {
          wrapper: Td,
          name: 'BadItemsItems',
          displayState: ({ isOpen }) => ({
            background: isOpen ? '#F3F5F5' : '#F9FAFA',
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '120px',
          }),
          elements: [
            {
              component: wrap(SecondaryTextSm, Px5),
              name: 'Items',
              displayValue: ({ item }) => `${item?.incomplete_items ?? 0}`,
            }
          ]
        },
        {
          wrapper: Td,
          name: 'BadItemsPercentage',
          displayState: ({ isOpen }) => ({
            borderRight: isOpen ? '' : '1px solid #E3E3E3',
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '120px',
          }),
          elements: [
            {
              component: wrap(SecondaryTextSm, Px5),
              name: 'Percentage',
              displayValue: ({ item }) => `${item?.incomplete_percentage ?? 0}%`,
            }
          ]
        },
        {
          wrapper: Td,
          name: 'Chart',
          displayState: ({ isOpen }) => ({
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '190px',
          }),
          elements: [
            {
              component: wrap(MultipleProgressBar, Px5),
              name: 'Progress',
              bindings: ({ item }) => ({ total: item?.total_items ?? 0, completed: item?.completed_items ?? 0, started: item?.incomplete_items ?? 0 }),
              displayState: ({ }) => ({ height: '10px' }),
            },
          ]
        },
        {
          wrapper: Td,
          name: 'Photos',
          displayState: ({ isOpen }) => ({
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '190px',
          }),
          elements: [
            {
              wrapper: wrap(FlexCenterBetweenWrapper, Px5),
              name: 'PhotosWrapper',
              elements: [
                {
                  component: wrap(SecondaryTextSm, Mr6),
                  name: 'Photos',
                  displayValue: ({ item }) => `${item?.attachments?.length ?? 0} ${item?.attachments?.length == 1 ? 'Photo' : 'Photos'}`,
                },
                {
                  wrapper: FlexCenterWrapper,
                  name: '__transparent__',
                  elements: [
                    {
                      component: wrap(ClickableIcon, Mr3),
                      name: 'DownloadImages',
                      renderIf: ({ item }) => item?.attachments?.length > 0,
                      bindings: ({ item }) => ({ item }),
                      displayValue: ({ }) => DownloadDocumentSvg({ width: 16, height: 16, color: '#1DBD6B' }),
                    },
                    {
                      component: ClickableIcon,
                      name: 'ViewImages',
                      renderIf: ({ item }) => item?.attachments?.length > 0,
                      bindings: ({ item }) => ({ item }),
                      displayValue: ({ }) => EyeSvg({ notCrossed: true, width: 16, height: 16, color: '#1DBD6B' }),
                    }
                  ]
                }
              ]
            }
          ]
        },

        // {
        //   wrapper: Td,
        //   name: 'Tags',
        //   displayState: ({ isOpen }) => ({
        //     borderBottom: isOpen ? '' : '1px solid #E3E3E3'
        //   }),
        //   elements: [
        //     {
        //       component: wrap(SecondaryTextSm, Px5),
        //       name: 'Tags',
        //       displayValue: ({ }) => 'Tags',
        //     }
        //   ]
        // },


        {
          wrapper: Td,
          name: 'Cost',
          displayState: ({ isOpen }) => ({
            borderRight: '1px solid #E3E3E3',
            borderBottom: isOpen ? '' : '1px solid #E3E3E3',
            borderTop: isOpen ? '1px solid #C2CCCE' : '',
            width: '100px',
          }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSmBold, Px5), FlexCenterJustifyEndWrapper),
              name: 'Cost',
              displayValue: ({ item }) => `$${formatPrice((item.costs ?? 0) / 100, true)}`
            }
          ]
        },
      ]
    },
    {
      wrapper: Tr,
      name: 'InfoRow',
      renderIf: ({ isOpen }) => isOpen,
      displayState: ({ }) => ({ height: '48px', background: '#F3F5F5', borderBottom: '1px solid #E3E3E3' }),
      elements: [
        {
          wrapper: Td,
          name: 'Breakdown',
          displayState: ({ }) => ({
            borderLeft: '1px solid #C2CCCE',
            borderBottom: '1px solid #C2CCCE',
          }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSmBold, Pl9), WhiteSpaceNoWrap),
              name: 'Text',
              displayValue: ({ }) => 'Action Required breakdown:'
            }
          ]
        },
        {
          wrapper: Td,
          name: 'Info',
          colSpan: 8,
          displayState: ({ }) => ({
            borderRight: '1px solid #C2CCCE',
            borderBottom: '1px solid #C2CCCE',
          }),
          elements: [
            {
              wrapper: wrap(FlexCenterWrapper, Px5),
              name: 'Stats',
              elements: [
                {
                  component: SecondaryTextSm,
                  name: 'None',
                  renderIf: ({ item }) => !item?.item_stats?.length || item?.item_stats?.length === 0,
                  displayValue: ({ }) => 'No Action Required',
                },
                {
                  wrapper: wrap(FlexCenterWrapper, Mr4),
                  name: 'Option',
                  isListOf: { stats: ({ item }) => item?.item_stats ?? [] },
                  elements: [
                    {
                      component: wrap(Icon, Mr2),
                      name: 'Icon',
                      renderIf: ({ stats }) => !!getIconByName({ name: stats.name }),
                      displayState: ({ }) => ({ color: window?.settings?.secondary_color }),
                      displayValue: ({ stats }) => getIconByName({ name: stats.name }),
                    },
                    {
                      component: wrap(SecondaryTextSm, Mr2),
                      name: 'Name',
                      displayValue: ({ stats }) => `${stats?.name ?? ''}:`
                    },
                    {
                      component: wrap(SecondaryTextSmBold, Mr2),
                      name: 'Cost',
                      displayValue: ({ stats }) => `$${formatPrice((stats.costs ?? 0) / 100, true)}`
                    },
                    {
                      component: wrap(SecondaryTextSm, Mr2),
                      name: 'Percentage',
                      renderIf: ({ stats, item }) => !!stats?.costs && !!item?.costs && stats.costs > 0,
                      displayValue: ({ stats, item }) => `(${Math.round((stats?.costs / item?.costs) * 100 ?? 0)}%)`
                    },
                    {
                      component: wrap(Bullet, Mr2),
                      name: 'Bullet',
                      displayValue: ({ }) => '',
                      displayState: ({ }) => ({ color: '#566F75', size: '4px' })
                    },
                    {
                      component: wrap(SecondaryTextSm, Mr2),
                      name: 'Count',
                      displayValue: ({ stats }) => `${stats?.count ?? 0} ${stats?.count > 1 ? 'Items' : 'Item'}`
                    },
                  ]
                },
              ]
            }
          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);
